<template>
  <div
    v-if="isSetPasskeyOpen"
    class="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex items-center justify-center p-4 z-50"
  >
    <div class="confirm-dialog max-w-[512px] w-full shadow-lg rounded-md bg-white">
      <h3 class="ml-6 mt-7 mb-4">
        {{ $t('messages.passkey.create_name_title') }}
      </h3>
      <div class="mb-4 px-6">
        <label
          for="displayName"
          class="sr-only"
        >{{ $t('messages.passkey.edit_display_name') }}</label>
        <input
          id="displayName"
          ref="displayNameInput"
          v-model="currentDisplayName"
          type="text"
          class="text-input p-4 text-left h-12 w-full"
        >
      </div>
      <div class="modal-footer hidden sm:flex justify-end">
        <button
          class="ml-3 mb-4 mr-4 button-primary min-w-[120px]"
          :disabled="!currentDisplayName || !currentDisplayName.trim()"
          @click="save"
        >
          {{ $t('messages.button.ok') }}
        </button>
      </div>
      <div class="modal-footer flex-col sm:hidden p-6">
        <button
          class="button-primary w-full mb-4"
          :disabled="!currentDisplayName || !currentDisplayName.trim()"
          @click="save"
        >
          {{ $t('messages.button.ok') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, watch, nextTick } from 'vue';

export default {
    name: 'SetPasskeyNameDialog',
    props: {
        isSetPasskeyOpen: {
            type: Boolean,
            required: true
        },
        passkey: {
            type: Object,
            default: null
        }
    },
    emits: ['save'],
    setup(props, { emit }) {
        const currentDisplayName = ref('');
        const displayNameInput = ref(null);

        watch(() => props.passkey, (newVal) => {
            if (newVal) {
                currentDisplayName.value = newVal.display_name || '';
            }
        }, { immediate: true });

        watch(() => props.isSetPasskeyOpen, async (isOpen) => {
            if (isOpen) {
                await nextTick();
                if (displayNameInput.value) {
                    // On mobile browsers, especially iOS, programmatically selecting text
                    // can be tricky. A common workaround is to use setSelectionRange
                    // inside a short timeout to ensure the focus event has completed.
                    displayNameInput.value.focus();
                    setTimeout(() => {
                        displayNameInput.value?.setSelectionRange(0, currentDisplayName.value.length);
                    }, 50);
                }
            }
        });

        const save = () => {
            if (props.passkey && currentDisplayName.value && currentDisplayName.value.trim()) {
                emit('save', {
                    ...props.passkey,
                    display_name: currentDisplayName.value.trim()
                });
            }
        };

        return {
            currentDisplayName,
            displayNameInput,
            save,
        };
    },
};
</script>